<script setup>
import { defineAsyncComponent, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
const store = useStore()
const baseInfo = defineAsyncComponent(() => import('../components/baseInfo.vue'))
const thinkSellGoods = defineAsyncComponent(() => import('../components/thinkSellGoods.vue'))
const infoSetting = defineAsyncComponent(() => import('../components/infoSetting.vue'))
const receivingAddress = defineAsyncComponent(() => import('../components/receivingAddress.vue'))
const thinkBuyGoods = defineAsyncComponent(() => import('../components/thinkBuyGoods.vue'))
const enterpriseUserOrder = ref('')
const tabNav = ref([
  { label: '基础信息', name: baseInfo, type: '1' },
  { label: '信息设置', name: infoSetting, type: '2' },
  { label: '收货地址', name: receivingAddress, type: '3' },
  { label: '所买商品', name: thinkBuyGoods, type: '4' },
  { label: '所卖商品', name: thinkSellGoods, type: '5' }
])
const activeName = ref(tabNav.value[0].type)

const handleClick = tab => {
  console.log(tab)
}

const handleSwitchTab = tabType => {
  if (tabType) {
    activeName.value = tabType
  }
}

const parseEnterpriseUserOrder = enterpriseCode => {
  if (typeof enterpriseCode !== 'string') {
    return ''
  }
  const matched = enterpriseCode.trim().match(/^.{3}(\d{10})$/)
  if (!matched) {
    return ''
  }
  return String(parseInt(matched[1], 10))
}

const initEnterpriseUserOrder = async () => {
  const userRes = await store.dispatch('myMessageModule/getUser')
  const { code, data = {} } = userRes?.data || {}
  if (code !== '0') {
    return
  }
  const enterpriseCode = data.enterpriseCode || data.enterpriseNo || ''
  enterpriseUserOrder.value = parseEnterpriseUserOrder(enterpriseCode)
}

onMounted(() => {
  initEnterpriseUserOrder()
})
</script>

<template>
  <div class="companyInfo">
    <div class="c">
      <!-- 顶部说明文案区域 -->
      <div class="welcome-card">
        <div class="welcome-card__content">
          <p class="welcome-card__title">
            恭喜贵公司正式成为盘雷工业数字链平台的第<span class="text-highlight">{{ enterpriseUserOrder || 'X' }}</span>位企业用户！
          </p>
          <p class="welcome-card__desc">
            &nbsp;&nbsp;&nbsp;&nbsp;盘雷是一个完全免费，开放协同的数字供应链平台。我们为企业提供便捷简单的账号管理体系：贵公司旗下所有员工均可以个人身份注册盘雷账号，系统将根据统一营业执照信息，自动将所有员工账号归集至贵司企业主体之下，实现"一个企业，多个协同节点"同时又完全独立。
          </p>
          <p class="welcome-card__section-title">关于企业信息管理与权限：</p>
          <p class="welcome-card__section-item">
            &nbsp;&nbsp;&nbsp;&nbsp;统一信息维护：公司的基本资料(如类型，介绍等)由首位注册的员工(即企业管理员)统一维护与修改。该权限亦可移交或由平台协助调整。
          </p>
          <p class="welcome-card__section-item">
            &nbsp;&nbsp;&nbsp;&nbsp;个人化业务设置：每位员工的合同用章，收款信息，开票资料及收货地址等，均由其本人在账户内独立设置与管理，保障业务灵活性与安全性。
          </p>
          <p class="welcome-card__section-item">
            &nbsp;&nbsp;&nbsp;&nbsp;平台将基于企业及员工完善的信息，智能推送匹配的销售商机与采购资源，助力业务精准对接。
          </p>
          <p class="welcome-card__footer">
            我们深知，信息越完善，协同越高效。盘雷将持续迭代，并计划推出"盘雷企业版"(集成CRM与动态库存管理功能)，进一步赋能企业的销售与采购数字化进程，与您共同释放供应链的最大价值。
          </p>
        </div>
        <div class="welcome-card__decoration"></div>
      </div>
      <!-- 主要内容 -->
      <div class="companyInfo__content">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
          <el-tab-pane v-for="(item, index) in tabNav" :label="item.label" :name="item.type" :key="index">
            <component
              v-if="activeName === item.type"
              :is="item.name"
              :key="item.type"
              @switch-tab="handleSwitchTab"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
// 变量定义（便于维护与主题切换）
@welcome-card-width: 100%;
@welcome-card-min-height: 232px;
@welcome-card-bg: linear-gradient(90deg, #ffffff, #e8f7fc);
@welcome-card-border-radius: 8px;
@welcome-card-padding: 24px 32px;
@color-primary: #20a080;
@color-highlight: #ff4d4f;
@color-text: #333333;
@color-text-secondary: #666666;

.companyInfo {
  height: 100%;
  padding: 20px 0;
  .c {
    width: 1400px;
    height: 100%;
    margin: 0 auto;
    .welcome-card {
      width: @welcome-card-width;
      min-height: @welcome-card-min-height;
      background: @welcome-card-bg;
      border-radius: @welcome-card-border-radius;
      padding: @welcome-card-padding;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      margin-bottom: 16px;
      background: linear-gradient(130deg, #ffffff 0%, #f5fbff 42.61%, #ebfdfa 100%);
      &__content {
        position: relative;
        z-index: 1;
        color: @color-text;
        line-height: 1.8;

        .text-highlight {
          color: @color-highlight;
          font-weight: 500;
        }

        &__title {
          font-size: 18px;
          font-weight: 600;
          margin: 0 0 12px 0;
        }

        &__desc {
          font-size: 16px;
          margin: 0 0 20px 0;
        }

        &__section-title {
          font-size: 17px;
          font-weight: 500;
          margin: 0 0 12px 0;
        }

        &__section-item {
          font-size: 16px;
          margin: 0 0 8px 0;
        }

        &__footer {
          font-size: 16px;
          margin: 12px 0 0 0;
        }
      }

      &__decoration {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 373px;
        height: 232px;
        background-image: radial-gradient(#67c8e8 1px, transparent 1px);
        background-size: 12px 12px;
        // 波浪裁剪路径（精准匹配设计图波浪形状）
        clip-path: polygon(0% 100%, 20% 80%, 40% 90%, 60% 70%, 80% 85%, 100% 75%, 100% 100%);
        opacity: 0.6;
        z-index: 0;
      }
    }
    .companyInfo__content {
      height: 100%;
      // background: #ffffff;

      .tabs {
        background: #ffffff;
        :deep(.el-tabs__item) {
          padding: 0 20px;
          height: 60px;
          line-height: 60px;
          font-size: 14px;
          color: #606666;
          border-bottom: 3px solid transparent; // 透明底部（激活时变绿色）
          transition: all 0.3s ease;
          &:hover {
            columns: #48a09c;
          }
          &.is-active {
            color: #48a09c; // 激活文字绿色
            border-bottom: 3px solid #48a09c; // 绿色下划线
            font-weight: 500;
          }
        }
      }
      :deep(.el-tabs__header) {
        border-bottom: 1px solid #e5e5e5;
      }
    }
  }
}
</style>
